import {generate} from "@containers/export/containers/buildData/helpers/helpers";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {HeadColumns} from "@ui/tableCustom/types/table";
import {
    IExportDataSetAdditionalItem,
    IExportDataSetItem
} from "@containers/export/containers/buildData/hooks/types/exportParams";


interface IProps<T> {
    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    exportDataFromAllPage?: boolean,
    allData?: T[],
    data: T[],
    additionalDataSet: IExportDataSetAdditionalItem<T>[],
    order: keyof T | false,
    direction: string,
    ignoredExportColumnKey?: string | null,
    t: (key: string) => string,
    rootDataSetPosition?: number
    exportFromAllColumns?: boolean,
    rootYSteps?: number,
}


export function generateExportDataSet<T>({
                                             columnExport,
                                             fullColumns,
                                             headColumns,
                                             exportDataFromAllPage,
                                             allData,
                                             data,
                                             additionalDataSet,
                                             order,
                                             direction,
                                             ignoredExportColumnKey,
                                             t,
                                             rootDataSetPosition,
                                             exportFromAllColumns,
                                             rootYSteps = 1,
                                         }: IProps<T>): IExportDataSetItem<unknown>[] {
    if (!columnExport || (!fullColumns && !headColumns)) {
        return []
    }

    const currentData = exportDataFromAllPage && allData ? allData : data;


    const exportData = generate({
        columnExport,
        fullColumns,
        headColumns,
        data: currentData,
        order,
        direction,
        t,
        ignoredExportColumnKey,
        exportFromAllColumns,
    })

    const dataSetArray: IExportDataSetItem<any>[] = [
        {
            data: exportData.data,
            columns: exportData.columns,
            headColumns: exportData.headColumns,
            position: rootDataSetPosition ?? 1,
            rootDataSet: true,
            ySteps: rootYSteps,

        }
    ]

    if (additionalDataSet?.length) {
        const dataArr: IExportDataSetItem<unknown>[] = additionalDataSet.map((item) => {
            const {
                columnExport,
                data,
                xSteps,
                ySteps,
            } = item;

            const exportData = generate<any>({
                columnExport,
                fullColumns: columnExport,
                data,
                t,
            })

            return {
                data: exportData.data ?? [],
                columns: exportData.columns,
                headColumns: exportData.headColumns,
                position: item.position ?? 0,
                rootDataSet: false,
                xSteps,
                ySteps,
                settings:item?.settings
            }
        })
        dataSetArray.unshift(...dataArr)
    }

    return dataSetArray.sort((a, b) => a.position - b.position);
}